module.exports = __webpack_public_path__ + "static/media/ios-home.b3a937c9.svg";